import React from 'react';
import QuestionResponse from '../../QuestionResponses/QuestionResponse';

import styles from './PageReview.module.scss';

/** One standard page's questions and the given responses, under its title. */
function StandardQuestionResponses({ page, questionMap, responses }) {
  return (
    <>
      <div className={styles['page-review-header']}>
        <h4 className={styles['page-review-title']}>{page.title}</h4>
      </div>
      <div className={styles['page-review-body']}>
        <div className={styles['standard-question-responses']}>
          {(page.elements ?? []).map((element) => {
            const question = questionMap[element.key];

            return question ? (
              <QuestionResponse
                key={question.id}
                question={question}
                response={responses[question.id]}
              />
            ) : null;
          })}
        </div>
      </div>
    </>
  );
}

export default StandardQuestionResponses;
